var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _class, _class2, _descriptor, _descriptor2, _descriptor3;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

/*!
 * @copyright
 * Copyright(c) 2019 SICK AG
 */
import { Component, CustomElement, html, Prop } from '@sick-davinci/ce-decorators';
import { style } from './ValueDisplay.style';
/**
 * A `davinci-value-display` displays text.
 * It can be used to show a value with its unit.
 *
 * @example
 * ```html
 * <davinci-value-display value="This is SICK!"></davinci-value-display>
 * <davinci-value-display value="50" unit="m"></davinci-value-display>
 * ```
 */

export let ValueDisplay = (_dec = Component({
  style: [style],
  tag: 'davinci-value-display'
}), _dec2 = Prop({
  reflectAsAttribute: false,
  type: String || Number
}), _dec3 = Reflect.metadata("design:type", Object), _dec4 = Prop(), _dec5 = Reflect.metadata("design:type", String), _dec6 = Prop(), _dec7 = Reflect.metadata("design:type", String), _dec(_class = (_class2 = class ValueDisplay extends CustomElement {
  constructor(...args) {
    super(...args);

    _initializerDefineProperty(this, "value", _descriptor, this);

    _initializerDefineProperty(this, "unit", _descriptor2, this);

    _initializerDefineProperty(this, "label", _descriptor3, this);
  }

  render() {
    return html`
      <div class="wrapper">
        <div>
          <label class="label">${this.label}</label>
        </div>
        <span class="value">${this.value}</span>
        <span class="unit">${this.unit}</span>
      </div>
    `;
  }

}, (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "value", [_dec2, _dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "unit", [_dec4, _dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "label", [_dec6, _dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
})), _class2)) || _class);
